<template>
  <div class="block_5 flex-col" id="job">
    <div class="grid_2 flex-row">
      <div
          class="list-items_1 flex-col alltime"
          v-for="(item, index) in jobList"
          :key="index"
      >
        <span class="text_43" v-html="item.job_name"></span>
        <div class="box_7 flex-row">
          <div class="image-text_4 flex-row justify-between">
            <img
                class="thumbnail_3"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/icon_dz.png')"
            />
            <span class="text-group_4" v-html="item.work_location" :title="'工作地点：'+item.education"></span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/icon_xl.png')"
            />
            <span class="text-group_5" v-html="item.education" :title="'要求学历：'+item.education"></span>
          </div>
          <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/icon_rs.png')"
          />
          <span class="text_44" v-html="item.department" :title="'公司/部门：'+item.department"></span>
        </div>
        <span class="text_45">专业方向</span>
        <span class="text_46" v-html="item.major_direction" :title="item.major_direction"></span>
        <span class="text_47">经验要求</span>
        <span class="text_48" v-html="item.experience" :title="item.experience"></span>
        <div class="box_8 flex-col"></div>
        <div class="text-wrapper_20">
          <span class="text_49">简历投递邮箱：</span>
          <span class="text_50">xhrs&#64;sailhero.com.cn</span>
        </div>
        <s></s>
      </div>
    </div>
    <div class="pagination flex-col">
      <Pagination v-show="total>0" :total="total" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"
                  @pagination="getData"/>
    </div>
  </div>
</template>

<script>
import Pagination from './Pagination'
export default {
  components: { Pagination },
  name: "jobPostings",
  data() {
    return {
      params:{
        pageIndex:1,
        pageSize:6,
      },
      total:0,
      jobList: [],
    };
  },
  methods: {
    //获取招聘职位列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getOpenPositions",
          {pageSize: _this.params.pageSize, pageIndex: _this.params.pageIndex},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.jobList = res.data;
            }
          }
      );
    },
  },
  mounted() {
    let that = this;
    that.getData();
  }
}
</script>

<style scoped>
.alltime,.alltime *{-webkit-transition: all .4s cubic-bezier(.4,0,.2,1); -moz-transition: all .4s cubic-bezier(.4,0,.2,1); transition: all .4s cubic-bezier(.4,0,.2,1);}

.grid_2 div s{display: block;width: 0%;height: 3px;background: #0057c1;position: absolute;left: 0;bottom: 0;}

.grid_2 div:hover s{width: 100%;}

.block_5 {
  background-color: rgba(249, 249, 249, 1);
  width: 1120px;
  height: 780px;
  position: relative;
  top: 20px;
}

.grid_2 {
  width: 1100px;
  height: 750px;
  flex-wrap: wrap;
  margin: 30px 0 20px 24px;
}
.list-items_1:hover{
  transform: scale(0.98);
}
.list-items_1 {
  box-shadow: 0px 0px 7px 0px rgba(158, 158, 158, 0.5);
  background-color: rgba(255, 255, 255, 1);
  width: 341px;
  height: 341px;
  margin: 0 25px 32px 0;
  cursor: pointer;
  position: relative;/*使子元素相对父元素进行绝对定位*/
}
.text_43 {
  width: 260px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  line-height: 26px;
  margin: 32px 0 0 24px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.box_7 {
  width: 410px;
  height: 19px;
  margin: 16px 0 0 24px;
  position: relative;
}
.image-text_4 {
  width: 62px;
  height: 19px;
}
.thumbnail_3 {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}
.text-group_4 {
  width: 72px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  line-height: 18px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.image-text_5 {
  width: 107px;
  height: 18px;
  margin-left: 45px;
}
.thumbnail_4 {
  width: 18px;
  height: 13px;
  margin-top: 2px;
}
.text-group_5 {
  width: 81px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  line-height: 18px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.thumbnail_5 {
  width: 17px;
  height: 18px;
  margin-left: 5px;
}
.text_44 {
  width: 55px;
  height: 18px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  line-height: 18px;
  margin-left: 8px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.text_45 {
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 18px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 15px 0 0 21px;
}
.text_46 {
  width: 310px;
  height: 51px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 16px;
  font-weight: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-align: left;
  line-height: 18px;
  margin: 15px 0 0 21px;
}
.text_47 {
  width: 88px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 18px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 22px;
  margin: 15px 0 0 21px;
}
.text_48 {
  width: 310px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  line-height: 20px;
  margin: 15px 0 0 21px;
}
.box_8 {
  background-color: rgba(13, 139, 255, 1);
  width: 302px;
  height: 1px;
  margin: 15px 0 0 21px;
}
.text-wrapper_20 {
  width: 293px;
  height: 16px;
  overflow-wrap: break-word;
  font-size: 0;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  margin: 18px 0 23px 21px;
}
.text_49 {
  width: 293px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(118, 118, 118, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}
.text_50 {
  width: 293px;
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(30, 123, 254, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
}
.text-wrapper_21 {
  background-color: rgba(13, 115, 255, 1);
  height: 50px;
  width: 1920px;
}
.text_51 {
  width: 839px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 14px;
  margin: 18px 0 0 541px;
}
.pagination{
  height: 22px;
  text-align: center;
}
</style>
